export function getGap(_inc) {
  return 0; // (inc > 10 ? 1 : 0);
}

// OPTIMIZED: Reduced object spreading
export function makeStepSegments(fillColorArr) {
  let segments = [];

  for (let i = 2; i < fillColorArr.length; i += 2) {
    let color = fillColorArr[i];
    let prevStep = fillColorArr[i - 1];
    let nextStep = fillColorArr[i + 1];
    let valueGap;
    let min = prevStep;

    if (i === 2 && fillColorArr.length > 5) {
      let increment = fillColorArr[i + 3] - nextStep;
      valueGap = getGap(increment);
      min = (nextStep) - increment - valueGap;
    } else {
      valueGap = getGap(nextStep - prevStep);
    }

    let max = nextStep - valueGap;

    if (i === fillColorArr.length - 1) {
      let increment = prevStep - fillColorArr[i - 3];
      valueGap = getGap(increment);
      max = (prevStep) + increment - valueGap;
    }

    segments.push({ color, min, max });
  }

  // OPTIMIZED: Simplified segment sampling
  if (segments.length > 50) {
    const maxSegment = 10;
    const skipGap = Math.floor(segments.length / maxSegment);
    const newSeg = [];

    for (let i = 0; i < segments.length; i += skipGap) {
      if (i + skipGap < segments.length) {
        newSeg.push({
          color: segments[i].color,
          min: segments[i].min,
          max: segments[i + skipGap - 1].max,
          range: `${segments[i].min} - ${segments[i + skipGap - 1].max}`
        });
      }
    }

    // Add last segment
    const last = segments[segments.length - 1];
    if (newSeg[newSeg.length - 1].max !== last.max) {
      newSeg.push({
        color: last.color,
        min: last.min,
        max: last.max,
        range: `${last.min} - ${last.max}`
      });
    }

    segments = newSeg;
  }

  return segments;
}

export function makeLayerSegments(layers) {
  let segments = [];

  for (let i = 0; i < layers.length; i++) {
    let type = layers[i].type;
    let color = layers[i].paint[type + '-color'];
    if (typeof color !== 'string') continue;
    let category = layers[i].id;
    segments.push({ category, color });
  }

  return segments;
}

export const makeMatchSegments = (colorExpression, customLabel, sizeExpression) => {
  const segments = [];

  for (let i = 2; i < colorExpression.length - 1; i += 2) {
    const color = colorExpression[i + 1];
    const category = colorExpression[i];
    const size = sizeExpression
      ? (sizeExpression[category] ? sizeExpression[category] : sizeExpression.other)
      : '';

    if (customLabel && customLabel[category]) {
      segments.push({ category: customLabel[category], color, size });
    } else {
      segments.push({ category, color, size });
    }
  }

  return segments;
};

export function collectLegend(inLayers) {
  let legend = {};
  const layers = inLayers.filter(l => l.hide_legend !== true);

  if (layers.length > 1) {
    legend = {
      type: 'category',
      segments: makeLayerSegments(layers),
      unit: '',
      symbol: layers[0] && layers[0].type
    };
    return legend;
  }

  const layer = layers[0];
  if (!layer.paint) { return null; }

  const colorExpression = layer.paint[layer.type + '-color'];
  const colorOutlineExpression = layer.paint[layer.type + '-outline-color'];

  if (!colorExpression && !colorOutlineExpression) { return null; }

  if (!(colorExpression instanceof Array)) {
    return {
      type: 'category',
      color: colorExpression,
      borderColor: colorOutlineExpression,
      unit: '',
      symbol: layers[0] && layers[0].type
    };
  }

  if (colorExpression[1][0] !== 'get') { return null; }

  const sizeExpression = {};
  if (layer.type === 'circle' && layer.paint[layer.type + '-radius']) {
    const sizeList = layer.paint[layer.type + '-radius'].find(x => x[0] === 'match');
    if (sizeList) {
      for (let i = 2; i < sizeList.length; i += 2) {
        if (i + 1 > sizeList.length - 1) {
          sizeExpression.other = sizeList[i];
        } else {
          const size = sizeList[i + 1];
          const category = sizeList[i];
          sizeExpression[category] = size;
        }
      }
    }
  }

  switch (colorExpression[0]) {
    case 'step': {
      const boundary = layer.value_boundary || {};
      const segments = makeStepSegments(colorExpression, boundary);
      legend = {
        type: 'range',
        segments,
        unit: '%',
        min: segments[0].min,
        max: segments[segments.length - 1].max,
        symbol: layer.type
      };

      if (boundary.min === false) {
        legend.min = segments[0].max;
        legend.minBoundary = false;
      }

      if (boundary.max === false) {
        legend.max = segments[segments.length - 1].min;
        legend.maxBoundary = false;
      }
      break;
    }
    case 'match':
      legend = {
        type: 'category',
        segments: makeMatchSegments(colorExpression, layer.custom_legend_label, sizeExpression),
        unit: '',
        symbol: layer.type
      };
      break;
    default:
      break;
  }

  return legend;
}
